import { render, staticRenderFns } from "./Mural.vue?vue&type=template&id=51de8efb&scoped=true&"
import script from "./Mural.vue?vue&type=script&lang=js&"
export * from "./Mural.vue?vue&type=script&lang=js&"
import style0 from "./Mural.vue?vue&type=style&index=0&id=51de8efb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51de8efb",
  null
  
)

export default component.exports